import actions from './actions'
import error from './error'
import general from './general'
import meta from './meta'
import navigation from './navigation'
import validation from './validation'
import auth from './auth'

export default {
    actions,
    general,
    error,
    meta,
    navigation,
    validation,
    auth,
}
